/**
 * ToggleButton component
 */
import Button from "../Button"

const ToggleButton = Button

export { _PropsComponent_ } from "../Button/Button"
export default ToggleButton
